<template>
  <b-list-group-item>
    {{itemopt.name}}
    <a style="float: right;" :href="'#'+$route.path">
      <b-icon icon="x-circle" variant="danger" font-scale="1.5" v-b-popover.hover.right="'Remove Option from Item'" @click="removeItemOption"></b-icon>
    </a>
  </b-list-group-item>
</template>
<script>
export default {
  name: 'ItemOptions',
  props: ['itemopt', 'item_id'],
  data () {
    return {

    }
  },

  methods: {
    emitRefreshOptions() {
      this.$emit('emit-refresh-options');
    },

    emitSwitchOverlay(bool) {
      this.$emit('emit-switch-overlay', bool);
    },

    async removeItemOption() {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      // update order with status of 'ready'
      const { data } = await this.$api.delete('items/'+this.item_id+'/optionheaders/'+this.itemopt.id,
        config
      );
      if (data.deleted == true) {
        this.emitRefreshOptions();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem removing the option from the item, please try again later.', {
          title: 'Error removing option',
          centered: true
        })
      }
    },

  },
}
</script>

<style>
</style>
